import { render } from "./Bloemen.vue?vue&type=template&id=8cbd2ede"
import script from "./Bloemen.vue?vue&type=script&lang=js"
export * from "./Bloemen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__